"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _AnalyticsFilter_1 = require("./_AnalyticsFilter");
var _StorageClassAnalysis_1 = require("./_StorageClassAnalysis");
exports._AnalyticsConfiguration = {
    type: "structure",
    required: ["Id", "StorageClassAnalysis"],
    members: {
        Id: {
            shape: {
                type: "string"
            }
        },
        Filter: {
            shape: _AnalyticsFilter_1._AnalyticsFilter
        },
        StorageClassAnalysis: {
            shape: _StorageClassAnalysis_1._StorageClassAnalysis
        }
    }
};
//# sourceMappingURL=_AnalyticsConfiguration.js.map